import HttpService from "./HttpService";

let relatorioQuantitativoService = {

    getRelatorio: (idAvaliacao, idCaderno, idEscola, idTurma) => {
        let url = `/relatorios/quantitativo?idAvaliacao=${idAvaliacao}&idCaderno=${idCaderno}`;
        if(idEscola)
            url += `&idEscola=${idEscola}`
        if(idTurma)
            url += `&idTurma=${idTurma}`
        return HttpService.backApi.get(url)
    },

    getAvaliacoes: () => {
        return HttpService.backApi.get('/relatorios/quantitativo/avaliacoes')
    },
    getCadernos: (idAvaliacao) => {
        return HttpService.backApi.get(`/relatorios/quantitativo/cadernos/${idAvaliacao}`)
    },
    getEscolas: (idAvaliacao, idCaderno) => {
        return HttpService.backApi.get(`/relatorios/quantitativo/escolas/${idAvaliacao}/${idCaderno}`)
    },
    getTurmas: (idAvaliacao, idCaderno, idEscola) => {
        return HttpService.backApi.get(`/relatorios/quantitativo/turmas/${idAvaliacao}/${idCaderno}/${idEscola}`)
    }

}

export default relatorioQuantitativoService;